import React from 'react';
import { Typography } from '@material-ui/core';
import AttendanceLogItem from './AttendanceLogItem';
import * as Unicons from '@iconscout/react-unicons';
import { connect } from 'react-redux';
import * as registerAttendaceAction from './../../actions/registerAttendace'

class AttendaceLogs extends React.Component{
    constructor(props){
        super(props);
        this.state={
            slidingPanelUpValue : 80,
            slidingPanelUp:false
        }
    }
    slidingPanelUp = (event) =>{
        event.preventDefault();
        let position = Math.round(event.screenY/10);
        if(position!==0){
            this.setState({slidingPanelUpValue:position});
        }
       
    }
    slidingPanelUpTouch = (event) =>{
        let position = Math.round(event.targetTouches[0].screenY/10);
        if(position!==0){
                this.setState({slidingPanelUpValue:position});
            }
    }
    slidingPanelStop = (event) => {
        event.preventDefault();
        if(this.state.slidingPanelUpValue < 70 && !this.state.slidingPanelUp){
            this.setState({slidingPanelUpValue:0});
            this.setState({slidingPanelUp:true});

        }
        else if(this.state.slidingPanelUpValue > 20 && this.state.slidingPanelUp){
            this.setState({slidingPanelUpValue:80});
            this.setState({slidingPanelUp:false});
        }
        else{
            this.setState({slidingPanelUpValue:82})
        }
    }
 
    render = () => {
        var  style = {
            bottom:"-" + this.state.slidingPanelUpValue + "%" 
        }
        if(this.props.registerAttendace.attendaceLogs){
            return(
                <div  className="attendance-log-container w-100" style={style} 
                onTouchMove={this.slidingPanelUpTouch}
                onTouchEnd={this.slidingPanelStop}
                onDrag={this.slidingPanelUp} 
                onDragEnd={this.slidingPanelStop} >
                    <div className="grab-handle"></div>
                    {this.props.registerAttendace.attendaceLogs.map((attendanceLog =>{
                    return <AttendanceLogItem key={attendanceLog.ID} {...attendanceLog}/>
                    }))}
    
                </div>
            );
        }
        else{
            return(
                <div  className="attendance-log-container w-100" style={style} 
                onTouchMove={this.slidingPanelUpTouch}
                onTouchEnd={this.slidingPanelStop}
                onDrag={this.slidingPanelUp} 
                onDragEnd={this.slidingPanelStop} >
                    <Typography align="center"><Unicons.UilAngleUp size={30} color="#000" /></Typography>
                </div>
            )
           
        }
        
    }
}
const mapStateToProps = (state) => {
    return state;
}
export default connect(mapStateToProps,registerAttendaceAction)(AttendaceLogs)